// extracted by mini-css-extract-plugin
export default {"codeBlock":"peSEFfI","summary":"QC0f_3I","credentialLabel":"hXThToG","credentialValue":"bj8IVoI","hiddenSecret":"aY5T9n0"};